import { PostViewer } from '@/components/PostViewer';
import { StudentProfilePreviewModal } from '@/components/ProfilePreviewModal';
import { useProfile } from '@/store';

export const GlobalModalsLayer = () => {
  const {
    roleCheck: { isStudent }
  } = useProfile();

  return (
    <div>
      {isStudent && <PostViewer isEditable={false} />}
      <StudentProfilePreviewModal />
    </div>
  );
};
